export const isEnumeratedSignalValue = (signalKey: string | undefined): boolean =>
  signalKey === 'snmp_bfd_session_up' || signalKey === 'snmp_bgp_peer_state' || signalKey === 'snmp_ospf_neighbor_state';

export const shouldShowSignalNumericMeta = (signalKey: string | undefined, numericValue: number | undefined): boolean =>
  numericValue != null && !isEnumeratedSignalValue(signalKey);
